import type { ReactNode } from 'react';

import { memo, Children } from 'react';

import useClassy from '@core/hooks/useClassy';
import Icon from '@ui/Icon';

import classes from './style.module.scss';

interface BreadcrumbProps {
  /**
   * Child elements to render as breadcrumb items
   */
  children: ReactNode;
  /**
   * Additional CSS class name
   */
  className?: string;
}

const Breadcrumb = memo(function Breadcrumb({ children, className }: BreadcrumbProps) {
  const bem = useClassy(classes, 'Breadcrumb');

  if (!children) {
    return null;
  }

  // Convert children to array for easier manipulation
  const childrenArray = Children.toArray(children);

  return (
    <div className={bem('&', 'rm-Breadcrumb', className)}>
      <ol className={bem('-list', 'rm-Breadcrumb-list')}>
        {childrenArray.map((child, index) => (
          <li key={index} className={bem('-item', 'rm-Breadcrumb-item')}>
            {child}
            {index < childrenArray.length - 1 && (
              <Icon aria-hidden="true" className={bem('-separator', 'rm-Breadcrumb-separator')} name="chevron-right" />
            )}
          </li>
        ))}
      </ol>
    </div>
  );
});

export default Breadcrumb;
